import NewTimecardPage from "@/components/screens/timecard/new";

export default function NewTimecard() {
  return <NewTimecardPage />;
}
